import styled from 'styled-components';
import {
  alignItems,
  flexbox,
  justifyContent
} from '../../styles/helpers/flexbox';

const FooterWrapper = styled.div(
  () => `   
    background: #94b4c9;
    padding: 0 5px;
    border-radius: 10px 10px 0 0;
    
    .buttonPanel {
       ${flexbox()}
       ${alignItems('center')}
       ${justifyContent('center')}

       height: 100%;
       
       .unassign {
         padding-right: 20px;
       }

       .actionsContainer {
         position: relative;
         ul {
           right: -1rem;
         }
       }

       .button {
         height: 30px;
       }
    }

    .collapsed {
      width: auto;
      padding: 0;
      font-weight: 700;
    }
`
);

export default FooterWrapper;



// WEBPACK FOOTER //
// ./components/footer/styled.js